module.exports = __webpack_public_path__ + "static/media/crismas.f20c1f62.png";